module.exports = __webpack_public_path__ + "static/media/logoAxalta.953839da.png";